import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Fired when a user runs a skill from the canvas empty state: an action chip, a scattered outcome card, or a "/skill" prompt submitted with an image held (typed by hand, or picked from the "/" skills list or the skill-word pill). Not fired on draft canvases that have no canvas_id yet.',
  name: 'canvas_empty_skill_selected',
  params: [
    {
      description:
        'The slash command of the selected skill (e.g. spin, ooh-mock) — for outcome_id "typed-prompt" this is the raw typed token and may not match a real skill',
      name: 'slash_command',
      required: true,
      type: 'string',
    },
    {
      description:
        'The null-state outcome that was selected. Chips and scattered cards report their catalog id, which distinguishes label variants that share a slash command (e.g. the animate vs convert-video copy test). A "/skill" prompt submitted with an image held reports "skill-suggestion" if that command was picked from the "/" list or the skill-word pill since the field was last empty, otherwise "typed-prompt"',
      name: 'outcome_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
